import { collapsibleValueGroup } from '~/components/AiSearchChips/OrValueGroupChip/orValueGroupCollapse';
import { nextPredicate } from '~/components/AiSearchChips/StringMatchChip/StringMatchChip.utils';
import { DRAFTS_OR_VALUE_GROUP_EDITORS } from '../draftsOrValueGroupFields';
export const collapsibleGroup = (arms)=>collapsibleValueGroup(DRAFTS_OR_VALUE_GROUP_EDITORS, arms);
export const collapsedGroupTone = (group, settingsTone)=>group.field === 'effectiveDate' ? settingsTone : undefined;
export const collapsedGroupArm = (group, index, value)=>{
    if (value == null) return undefined;
    return group.kind === 'string' ? {
        [group.field]: nextPredicate(value, group.predicates[index])
    } : {
        [group.field]: {
            eq: value
        }
    };
};
export const armChipTestIds = (armTestId)=>({
        AgreementName: "".concat(armTestId, "-agreement-name"),
        ClientName: "".concat(armTestId, "-client-name"),
        ClientPresence: "".concat(armTestId, "-client-presence"),
        Reviewers: "".concat(armTestId, "-reviewers"),
        ContactName: "".concat(armTestId, "-contact-name"),
        Status: "".concat(armTestId, "-status"),
        EffectiveDate: "".concat(armTestId, "-effective-date"),
        EffectiveDateMode: "".concat(armTestId, "-effective-date-mode"),
        LastUpdated: "".concat(armTestId, "-last-updated"),
        ModifiedBy: "".concat(armTestId, "-modified-by"),
        NetDays: "".concat(armTestId, "-net-days"),
        Settings: "".concat(armTestId, "-settings"),
        Services: "".concat(armTestId, "-services"),
        Packages: "".concat(armTestId, "-packages"),
        Bundles: "".concat(armTestId, "-bundles"),
        AndConnector: (index)=>"".concat(armTestId, "-and-connector-").concat(index)
    });
